import Vue from 'vue';

 // 获取地址栏参数
Vue.prototype.$getRequestParam = (name) => {
  var url = decodeURI(window.location.search);
    url = url.substr(1, url.length);
    var paramArray = url.split("&");
    for(var i = 0; i < paramArray.length; i++){
      var key = paramArray[i].split("=")[0];
      var value = paramArray[i].split("=")[1];
       if(key == name){
         return value;
       }
    }
    return ;
}